import { normalizarData, normalizarValor } from '../../utils/index';

/**
 * Retorna TRUE se a primeira linha tiver 'Extrato Conta Corrente' e encontrar as colunas
 * específicas do PagSeguro ('Data Lançamento', 'Histórico', 'Descrição').
 */
export const detectar = (dadosArray) => {
    let isExtrato = false;
    let hasColunasPagSeguro = false;

    // A linha 1 costuma ter " Extrato Conta Corrente "
    if (dadosArray && dadosArray.length > 0) {
        const primeiraLinha = dadosArray[0];
        if (Array.isArray(primeiraLinha) && primeiraLinha.length > 0) {
            const A1 = String(primeiraLinha[0] || '').trim().toUpperCase();
            if (A1.includes('EXTRATO CONTA CORRENTE')) {
                isExtrato = true;
            }
        }
    }

    if (!isExtrato) return false;

    // Procura colunas exclusivas do PagSeguro (usando substring sem acento para não quebrar em ANSI)
    for (let i = 0; i < Math.min(dadosArray.length, 15); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const str = linha.map(col => String(col || '').toUpperCase().trim());
        const temDataLan = str.some(c => c.includes('DATA LAN'));
        const temHistorico = str.some(c => c.includes('HIST'));
        const temDescricao = str.some(c => c.includes('DESCRI'));

        if (temDataLan && (temHistorico || temDescricao)) {
            hasColunasPagSeguro = true;
            break;
        }
    }

    return isExtrato && hasColunasPagSeguro;
};

/**
 * Processa a planilha bruta e retorna array mapeado.
 */
export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let idxData = -1;
    let idxHistorico = -1;
    let idxDescricao = -1;
    let idxValor = -1;

    for (let i = 0; i < Math.min(dadosArray.length, 15); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const str = linha.map(col => String(col || '').toUpperCase().trim());
        const tempIdxData = str.findIndex(c => c.includes('DATA LAN'));
        const tempIdxHistorico = str.findIndex(c => c.includes('HIST'));
        const tempIdxDescricao = str.findIndex(c => c.includes('DESCRI'));
        const tempIdxValor = str.findIndex(c => c === 'VALOR' || c.includes('VALOR'));

        if (tempIdxData !== -1 && tempIdxValor !== -1) {
            idxCabecalho = i;
            idxData = tempIdxData;
            idxHistorico = tempIdxHistorico;
            idxDescricao = tempIdxDescricao;
            idxValor = tempIdxValor;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Extrato PagSeguro não encontrado.');
    }

    const extrato = [];
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const dataStr = String(linha[idxData] || '').trim();
        if (!dataStr) continue;

        const data = normalizarData(dataStr);
        if (!data) continue;

        let valorStr = String(linha[idxValor] || '').trim();
        if (!valorStr) continue;

        let historico = idxHistorico !== -1 ? String(linha[idxHistorico] || '').trim() : '';
        let descricao = idxDescricao !== -1 ? String(linha[idxDescricao] || '').trim() : '';
        
        let valor = normalizarValor(valorStr);

        // A regra de segurança master: extrair todos os valores positivos!
        if (valor !== null && valor > 0) {
            let tipoVisivel = historico;
            if (descricao) tipoVisivel += ' - ' + descricao;

            extrato.push({
                linha: i + 1,
                data: data,
                valor: valor,
                tipo: tipoVisivel,
                dataOriginal: dataStr,
                valorOriginal: valorStr
            });
        }
    }

    return extrato;
};